export default "__VITE_ASSET__EL55rx34__"